import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-center p-3",
  style: {
    "color": "var(--el-text-color-primary)"
  }
};
import { ref } from "vue";
import lodash from "lodash";
import { validateEmail, validateMobile } from "@/utils/validate";
import { httpGet, httpPost } from "@/utils/http";
import CaptchaPlus from "@/components/CaptchaPlus.vue";
import SlideCaptcha from "@/components/SlideCaptcha.vue";
import { isMobile } from "@/utils/libs";
import { showMessageError, showMessageOK } from "@/utils/dialog";
export default {
  __name: 'Captcha',
  emits: ["success"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const show = ref(false);
    const maxDot = ref(5);
    const imageBase64 = ref("");
    const thumbBase64 = ref("");
    const captKey = ref("");
    const dots = ref(null);
    const isMobileInternal = isMobile();
    const emits = __emit;
    const handleRequestCaptCode = () => {
      httpGet("/captcha/get").then(res => {
        const data = res.data;
        imageBase64.value = data.image;
        thumbBase64.value = data.thumb;
        captKey.value = data.key;
      }).catch(e => {
        showMessageError("获取人机验证数据失败：" + e.message);
      });
    };
    const handleConfirm = dts => {
      if (lodash.size(dts) <= 0) {
        return showMessageError("请进行人机验证再操作");
      }
      let dotArr = [];
      lodash.forEach(dts, dot => {
        dotArr.push(dot.x, dot.y);
      });
      dots.value = dotArr.join(",");
      httpPost("/captcha/check", {
        dots: dots.value,
        key: captKey.value
      }).then(() => {
        // ElMessage.success('人机验证成功')
        show.value = false;
        emits("success", {
          key: captKey.value,
          dots: dots.value
        });
      }).catch(() => {
        showMessageError("人机验证失败");
        handleRequestCaptCode();
      });
    };
    const loadCaptcha = () => {
      show.value = true;
      // 手机用滑动验证码
      if (isMobile()) {
        getSlideCaptcha();
      } else {
        handleRequestCaptCode();
      }
    };

    // 滑动验证码
    const bgImg = ref("");
    const bkImg = ref("");
    const result = ref(0);
    const getSlideCaptcha = () => {
      result.value = 0;
      httpGet("/captcha/slide/get").then(res => {
        bkImg.value = res.data.bkImg;
        bgImg.value = res.data.bgImg;
        captKey.value = res.data.key;
      }).catch(e => {
        showMessageError("获取人机验证数据失败：" + e.message);
      });
    };
    const handleSlideConfirm = x => {
      httpPost("/captcha/slide/check", {
        key: captKey.value,
        x: x
      }).then(() => {
        result.value = 1;
        show.value = false;
        emits("success", {
          key: captKey.value,
          x: x
        });
      }).catch(() => {
        result.value = 2;
      });
    };

    // 导出方法以便父组件调用
    __expose({
      loadCaptcha
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "captcha-box"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_dialog, {
          modelValue: show.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => show.value = $event),
          "close-on-click-modal": true,
          "show-close": _unref(isMobileInternal),
          style: {
            "width": "360px",
            "--el-dialog-padding-primary": "5px 15px 15px 15px"
          }
        }, {
          title: _withCtx(() => [_unref(isMobileInternal) ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [_createElementVNode("span", null, "人机验证", -1)]))) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_unref(isMobileInternal) ? (_openBlock(), _createBlock(SlideCaptcha, {
            key: 0,
            "bg-img": bgImg.value,
            "bk-img": bkImg.value,
            result: result.value,
            onRefresh: getSlideCaptcha,
            onConfirm: handleSlideConfirm,
            onHide: _cache[0] || (_cache[0] = $event => show.value = false)
          }, null, 8, ["bg-img", "bk-img", "result"])) : (_openBlock(), _createBlock(CaptchaPlus, {
            key: 1,
            "max-dot": maxDot.value,
            "image-base64": imageBase64.value,
            "thumb-base64": thumbBase64.value,
            width: "300",
            onClose: _cache[1] || (_cache[1] = $event => show.value = false),
            onRefresh: handleRequestCaptCode,
            onConfirm: handleConfirm
          }, null, 8, ["max-dot", "image-base64", "thumb-base64"]))]),
          _: 1
        }, 8, ["modelValue", "show-close"])]),
        _: 1
      });
    };
  }
};